import { Controller } from "@hotwired/stimulus"
import { formatDate, formatPln, getJSON, listResults } from "../api.js"

// Kredyty organizacji: saldo (/balance/) + historia (read-only).
export default class extends Controller {
  static targets = ["rows", "status", "balance"]
  static values = {
    url: String,        // /api/credits/
    balanceUrl: String, // /api/credits/balance/
  }

  connect() { this.load() }

  async load() {
    let list
    let balance
    try {
      ;[list, balance] = await Promise.all([
        getJSON(this.urlValue),
        getJSON(this.balanceUrlValue),
      ])
    } catch {
      this.#status("Nie udało się załadować kredytów. Odśwież stronę.")
      return
    }
    if (this.hasBalanceTarget) this.balanceTarget.textContent = formatPln(balance.balance_pln)

    const credits = listResults(list)
    this.rowsTarget.textContent = ""
    if (!credits.length) {
      this.#status("Brak kredytów.")
      return
    }
    this.#status(null)
    const template = document.getElementById("credit-row-template")
    for (const credit of credits) {
      const row = template.content.firstElementChild.cloneNode(true)
      row.querySelector('[data-field="amount"]').textContent = formatPln(credit.amount_pln)
      row.querySelector('[data-field="note"]').textContent = credit.note || "—"
      row.querySelector('[data-field="complaint"]').textContent =
        credit.complaint ? `reklamacja #${credit.complaint}` : "—"
      row.querySelector('[data-field="created"]').textContent = formatDate(credit.created)
      this.rowsTarget.appendChild(row)
    }
  }

  #status(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.hidden = message === null
    if (message !== null) this.statusTarget.textContent = message
  }
}
